import { formatNumber } from '../../../utils';
import { fetchVisitedStatistics } from './organization-statistics-actions';
import moment from 'moment';
import OrganizationStatisticsChart from './OrganizationStatisticsChart';
import { useState } from 'react';

const OrganizationVisited = ({ organizationId, from, to, setFrom, setTo }) => {
    const [errorMessage, setErrorMessage] = useState('');
    return (
        <OrganizationStatisticsChart
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={setTo}
            organizationId={organizationId}
            dataKey={'Antall'}
            title={'Besøkstall'}
            yAxisLabel={'Besøk'}
            tooltipFormatFunction={formatNumber}
            contextMessage={'Besøkstall er kun tilgjenglig for besøk fra og med 18. september 2024'}
            errorMessage={errorMessage}
            fetchData={({ baseURL, organizationId, from, to }) => {
                setErrorMessage('');
                return fetchVisitedStatistics({
                    baseURL,
                    organizationId,
                    from: moment(from, 'DD.MM.YYYY').min(moment('18.09.2024', 'DD.MM.YYYY')).format('YYYY-MM-DD'),
                    to: moment(to, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                }).catch(() => {
                    setErrorMessage('Klarte ikke å hente statistikk. Vennligst prøv igjen senere.');
                });
            }}
        />
    );
};
export default OrganizationVisited;
